"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _default = _react.default.createClass({
  displayName: "UINavItemLabel",
  propTypes: {
    children: _react.PropTypes.node,
    count: _react.PropTypes.node
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className;
    return (0, _classNames.default)('private-nav-item__label', className);
  },
  renderCountValue: function renderCountValue(count) {
    if (!count) return null;
    return _react.default.createElement("span", {
      className: "private-nav-item__count"
    }, count);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        count = _this$props.count,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "count"]);
    return _react.default.createElement("span", (0, _extends2.default)({}, rest, {
      className: this.getClassName({
        className: className
      })
    }), _react.default.createElement("span", null, children), this.renderCountValue(count));
  }
});

exports.default = _default;
module.exports = exports.default;